import {
	ForgotPinRequest,
	OperationResponse,
	RemovePinRequest,
	SetPinRequest,
	VerifyPinRequest,
} from '../../proto/generated/identity'
import api from './axiosClient'

export async function setPin(
	request: Partial<SetPinRequest> & Pick<SetPinRequest, 'pin'>
): Promise<OperationResponse> {
	const body = SetPinRequest.fromPartial({
		verificationRequestId: '',
		verificationOtp: '',
		pinSetupToken: '',
		...request,
	})
	const res = await api.post('/auth/set-pin', JSON.stringify(SetPinRequest.toJSON(body)), {
		headers: { Accept: 'application/x-protobuf', 'X-Suppress-Error': 'true' },
		responseType: 'arraybuffer',
	})
	return OperationResponse.decode(new Uint8Array(res.data))
}

export async function verifyPin(request: Partial<VerifyPinRequest> & Pick<VerifyPinRequest, 'pin'>): Promise<OperationResponse> {
	const body = VerifyPinRequest.fromPartial(request)
	const res = await api.post('/auth/verify-pin', JSON.stringify(VerifyPinRequest.toJSON(body)), {
		headers: { Accept: 'application/x-protobuf', 'X-Suppress-Error': 'true' },
		responseType: 'arraybuffer',
	})
	return OperationResponse.decode(new Uint8Array(res.data))
}

export async function forgotPin(
	request: Partial<ForgotPinRequest> & Pick<ForgotPinRequest, 'newPin'>
): Promise<OperationResponse> {
	const body = ForgotPinRequest.fromPartial({
		verificationRequestId: '',
		verificationOtp: '',
		...request,
	})
	const res = await api.post('/auth/forgot-pin', JSON.stringify(ForgotPinRequest.toJSON(body)), {
		headers: { Accept: 'application/x-protobuf', 'X-Suppress-Error': 'true' },
		responseType: 'arraybuffer',
	})
	return OperationResponse.decode(new Uint8Array(res.data))
}

export async function removePin(
	request: Partial<RemovePinRequest>
): Promise<OperationResponse> {
	const body = RemovePinRequest.fromPartial(request)
	const res = await api.post('/auth/remove-pin', JSON.stringify(RemovePinRequest.toJSON(body)), {
		headers: { Accept: 'application/x-protobuf' },
		responseType: 'arraybuffer',
	})
	return OperationResponse.decode(new Uint8Array(res.data))
}
